import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment TermItem on TermModel {
    id
    preferred
    synonyms
    definition
    notes
    categories {
      id
      title
    }
    seeAlso {
      id
      preferred
    }
    comments {
      id
    }
    updatedAt
    updatedBy {
      subjectId
      name
    }
  }
`);

gql(/* GraphQL */ `
  fragment TermCommentModelItem on TermCommentModel {
    id
    text
    status
    isPinned
    createdBy {
      subjectId
      name
    }
    createdAt
    updatedBy {
      subjectId
      name
    }
    updatedAt
    closedAt
    closedBy {
      subjectId
      name
    }
    replies {
      id
      comment
      createdBy {
        subjectId
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const GET_ALL = gql(/* GraphQL */ `
  query GetTerms {
    terms(order: { preferred: ASC }) {
      ...TermItem
    }
  }
`);

export const GET = gql(/* GraphQL */ `
  query GetTerm($id: UUID!) {
    term(id: $id) {
      ...TermItem
      comments {
        ...TermCommentModelItem
      }
      versions {
        version
        createdAt
        createdBy {
          subjectId
          name
        }
        preferred
        synonyms
        categories {
          id
          title
        }
        seeAlso {
          id
          preferred
        }
        definition
        notes
        restoredFromVersion
        changedFields
      }
    }
  }
`);

export const ADD = gql(/* GraphQL */ `
  mutation TermAdd($input: TermAddInput!) {
    termAdd(input: $input) {
      termModel {
        ...TermItem
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`);

export const UPDATE = gql(/* GraphQL */ `
  mutation TermUpdate($input: TermUpdateInput!) {
    termUpdate(input: $input) {
      termModel {
        ...TermItem
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`);

export const RESTORE = gql(/* GraphQL */ `
  mutation TermRestore($input: TermRestoreInput!) {
    termRestore(input: $input) {
      termModel {
        ...TermItem
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`);

export const DELETE = gql(/* GraphQL */ `
  mutation TermDelete($input: TermDeleteInput!) {
    termDelete(input: $input) {
      uuid
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`);

export const ADD_COMMENT = gql(/* GraphQL */ `
  mutation TermCreateComment($input: TermCreateCommentInput!) {
    termCreateComment(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT = gql(/* GraphQL */ `
  mutation TermUpdateComment($input: TermUpdateCommentInput!) {
    termUpdateComment(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT = gql(/* GraphQL */ `
  mutation TermDeleteComment($input: TermDeleteCommentInput!) {
    termDeleteComment(input: $input) {
      termCommentModel {
        id
      }
    }
  }
`);

export const UPDATE_STATUS = gql(/* GraphQL */ `
  mutation TermUpdateCommentStatus($input: TermUpdateCommentStatusInput!) {
    termUpdateCommentStatus(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const PIN_COMMENT = gql(/* GraphQL */ `
  mutation TermPinComment($input: TermPinCommentInput!) {
    termPinComment(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const ADD_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation TermCreateCommentReply($input: TermCreateCommentReplyInput!) {
    termCreateCommentReply(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation TermUpdateCommentReply($input: TermUpdateCommentReplyInput!) {
    termUpdateCommentReply(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation TermDeleteCommentReply($input: TermDeleteCommentReplyInput!) {
    termDeleteCommentReply(input: $input) {
      termCommentModel {
        ...TermCommentModelItem
      }
    }
  }
`);

export const TERMLEX_DEFINITIONS = gql(/* GraphQL */ `
  query TermlexDefinitions($term: String!) {
    termlexDefinitions(term: $term) {
      identifier
      term
      definition
      source
      url
    }
  }
`);
